import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const PersonIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-person-icon ${className}`, height: '12.666', viewBox: '0 0 12.667 12.666', width: '12.667', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M11.875,12.666H.792A.793.793,0,0,1,0,11.874v-.791C0,10.435.412,9.5,2.374,8.71a11.761,11.761,0,0,1,3.959-.794,11.761,11.761,0,0,1,3.96.794c1.962.787,2.374,1.725,2.374,2.373v.791A.793.793,0,0,1,11.875,12.666ZM6.333,6.333A3.166,3.166,0,1,1,9.5,3.167,3.17,3.17,0,0,1,6.333,6.333Z', fill: '#a1a7b2', id: 'Icon' }) })));
PersonIcon.propTypes = {
    className: propStr(),
};
PersonIcon.defaultProps = {
    className: '',
};
export default PersonIcon;
